/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBBLACKLIST = 'GETCLUBBLACKLIST'



// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/constants.js